export const DIRECTORIES_COMPANY_SLICE = 'DIRECTORIES_COMPANY_SLICE';
